import { allowAccess } from "../../utils/accessControl";
import { Route, Navigate } from "react-router";


const ProtectedRoute = ({ allowedRole, path = "", redirectPath = '/login', children }) => {
    const nav = <Navigate to={redirectPath} replace />
    if (!allowAccess(allowedRole)) {
        return nav
    }
    
      console.log(children)
      return children
    
  };

export default ProtectedRoute